import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Layout, Progress, BackTop, Modal, Icon } from 'antd';

import './index.scss';

import { resetReduxState, logOutUser } from '../../data/redux/admin_details/actions';
import { makeChatsSocketConnection, chatsSocketDisconnect, emitMessageSeen, callChatsSocketMethod } from '../../data/redux/chats_details/actions';
import { makeMemberPageSocketConnection, memberSocketDisconnect } from '../../data/redux/member_details/actions';
import { APP_LAYOUT, COLORS, ROUTE_PATH, LOCAL_STORAGE } from '../../data/config/constants';
import { SOCKET_URLS, MODULE_CONFIG } from '../../data/config/urls';
import { showMessage, log, setTitleAsPath, checkInternetConnection } from '../../data/config/utils';

import AppHeader from '../../components/appheader';
import AppSider from '../../components/appsider';

const { Header, Sider, Content } = Layout;

class PageContainer extends Component {
  state = {
    sider_collapsed: true,
    page_progress: false,
    showLogoutPopup: false
  };

  componentDidMount() {
    const { is_chats_socket_connected, is_member_socket_connected, actions } = this.props;
    document.addEventListener("visibilitychange", this.onTabVisibilityChange);
    document.addEventListener("focusin", this.onTabVisibilityChange);
    window.addEventListener('click', this.resetTimeOut);
    window.addEventListener('mousemove', this.resetTimeOut);
    window.addEventListener('keypress', this.resetTimeOut);
    window.addEventListener('wheel', this.resetTimeOut);
    this.startUserActivityTimer();
    if (!is_chats_socket_connected) {
      fetch("https://api.ipify.org?format=json")
        .then(response => response.json())
        .then(data => actions.makeChatsSocketConnection(SOCKET_URLS.LIVE_CONVERSATIONS_SOCKET_URL, data.ip))
        .catch(() => actions.makeChatsSocketConnection(SOCKET_URLS.LIVE_CONVERSATIONS_SOCKET_URL))
    }
    if (!is_member_socket_connected) {
      actions.makeMemberPageSocketConnection(SOCKET_URLS.MEMBER_SOCKET_URL);
    }
    setTitleAsPath();
  }

  componentDidUpdate(prevProps) {
    const { is_internet_connected, is_chats_socket_connected, actions } = this.props
    setTitleAsPath();
    if (!prevProps.is_internet_connected && is_internet_connected && !is_chats_socket_connected)
      actions.callChatsSocketMethod('open')
    else if (prevProps.is_internet_connected && !is_internet_connected && is_chats_socket_connected)
      actions.callChatsSocketMethod('close')
    if (prevProps.is_chats_socket_connected !== is_chats_socket_connected)
      checkInternetConnection()
  }

  componentWillUnmount() {
    const { actions, dashboard_socket_details } = this.props;
    document.removeEventListener("visibilitychange", this.onTabVisibilityChange);
    document.removeEventListener("focusin", this.onTabVisibilityChange);
    window.removeEventListener('click', this.resetTimeOut);
    window.removeEventListener('mousemove', this.resetTimeOut);
    window.removeEventListener('keypress', this.resetTimeOut);
    window.removeEventListener('wheel', this.resetTimeOut);
    if (this.logoutWarningTimer)
      clearTimeout(this.logoutWarningTimer)
    if (this.logoutTimer)
      clearTimeout(this.logoutTimer);
    if (dashboard_socket_details && dashboard_socket_details.socket && dashboard_socket_details.socket.close)
      dashboard_socket_details.socket.close();
    actions.chatsSocketDisconnect();
    actions.memberSocketDisconnect();
  }

  onTabVisibilityChange = () => {
    const { location, actions } = this.props;
    if (document.visibilityState === 'visible' && document.hasFocus() && location && location.pathname === ROUTE_PATH.CHATS)
      actions.emitMessageSeen();
  }

  startUserActivityTimer = () => {
    this.logoutWarningTimer = setTimeout(this.showLogoutWarningPopup, MODULE_CONFIG.GLOBAL.AUTO_LOGOUT.SHOW_POPUP_TIME);
  }

  resetTimeOut = () => {
    if (this.logoutWarningTimer)
      clearTimeout(this.logoutWarningTimer)
    this.startUserActivityTimer();
  }

  showLogoutWarningPopup = () => {
    const modal = Modal.confirm({
      title: MODULE_CONFIG.GLOBAL.AUTO_LOGOUT.POPUP_TITLE,
      content: MODULE_CONFIG.GLOBAL.AUTO_LOGOUT.POPUP_CONTENT,
      icon: <Icon type="info-circle" className="ori-font-primary" />,
      onOk: this.logout,
      onCancel: this.onCloseLogoutPopup,
    });
    this.logoutTimer = setTimeout(() => {
      modal.destroy();
      this.onCloseLogoutPopup();
      this.logout();
    }, MODULE_CONFIG.GLOBAL.AUTO_LOGOUT.AUTO_LOGOUT_TIME);
  }

  onCloseLogoutPopup = () => {
    if (this.logoutWarningTimer)
      clearTimeout(this.logoutWarningTimer)
    if (this.logoutTimer)
      clearTimeout(this.logoutTimer);
    this.startUserActivityTimer();
  }

  logout = () => {
    const { actions } = this.props;
    const { history, admin_email } = this.props;
    actions.logOutUser({ email: admin_email }, () => {
      localStorage.removeItem(LOCAL_STORAGE.ORI_ADMIN);
      localStorage.removeItem(LOCAL_STORAGE.LIVE_CHATS_UNREAD_MESSAGE_COUNT);
      showMessage("success", "You have successfully logged out.");
      history.push(ROUTE_PATH.LOGIN);
      actions.resetReduxState();
    });
  }

  onCollapse = (collapse, type) => {
    if (type.toLowerCase() === "clicktrigger") {
      this.setState((prevState) => ({
        sider_collapsed: !prevState.sider_collapsed
      }));
    }
  }

  navigateTo = path => {
    this.props.history.push(path);
  }

  collapseSider = () => this.setState({ sider_collapsed: true })

  setBackTopTarget = () => document.getElementById('pageContainerBody')

  render() {
    let { sider_collapsed, page_progress } = this.state;
    const { screen_height, screen_width } = this.props;
    const collapsed_width = screen_width >= 768 ? APP_LAYOUT.APP_SIDER_COLLAPSE_WIDTH : 0;
    log('pageContainer rendered');
    return (
      <Layout className="oriAppLayoutContainer" style={{ minHeight: `${screen_height}px` }}>
        <Header className="ori-fixed ori-full-width ori-box-shadow ori-flex-row ori-flex-jfe appHeaderContainer" style={{ height: `${APP_LAYOUT.APP_HEADER_HEIGHT}px`, lineHeight: `${APP_LAYOUT.APP_HEADER_HEIGHT}px` }}>
          <AppHeader logout={this.logout} />
        </Header>
        <Sider className="ori-fixed ori-r-border-default appSiderContainer" style={{ height: screen_height }} breakpoint="md" collapsible defaultCollapsed={true} collapsed={sider_collapsed} collapsedWidth={collapsed_width} onCollapse={this.onCollapse}>
          <AppSider navigateTo={this.navigateTo} sider_collapsed={sider_collapsed} />
        </Sider>
        <Layout className="contentLayoutContainer" style={{ paddingTop: `${APP_LAYOUT.APP_HEADER_HEIGHT}px`, paddingLeft: `${collapsed_width}px` }}>
          {
            page_progress &&
            <div className="ori-absolute contentProgressContainer" style={{ top: `${APP_LAYOUT.APP_HEADER_HEIGHT - 8}px`, left: `${collapsed_width}px` }}>
              <Progress strokeWidth={7} strokeLinecap="square" showInfo={false} strokeColor={COLORS.primary_bg} percent={85} status="active" />
            </div>
          }
          {
            !sider_collapsed &&
            <div className="ori-animated ori-fade-in ori-absolute ori-bg-black-light overlay" onClick={this.collapseSider}>&nbsp;</div>
          }
          <Content>
            <div className="ori-full-width ori-overflow-auto ori-bg-default" style={{ height: `${screen_height - APP_LAYOUT.APP_HEADER_HEIGHT}px` }} id='pageContainerBody'>
              <BackTop target={this.setBackTopTarget} />
              {this.props.children}
            </div>
          </Content>
        </Layout>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    is_internet_connected: state.page_details.is_internet_connected,
    is_chats_socket_connected: state.chats_details.is_socket_connected,
    is_member_socket_connected: state.member_details.is_socket_connected,
    screen_height: state.page_details.device_data.screen_height,
    screen_width: state.page_details.device_data.screen_width,
    admin_email: state.admin_details.user_info.email,
    dashboard_socket_details: state.dashboard_details.socket_details,
  };
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        makeChatsSocketConnection,
        chatsSocketDisconnect,
        callChatsSocketMethod,
        emitMessageSeen,
        makeMemberPageSocketConnection,
        memberSocketDisconnect,
        resetReduxState,
        logOutUser,
      }, dispatch),
  };
}

PageContainer.propTypes = {
  location: PropTypes.object,
  actions: PropTypes.object,
  is_internet_connected: PropTypes.bool,
  is_chats_socket_connected: PropTypes.bool,
  is_member_socket_connected: PropTypes.bool,
  screen_height: PropTypes.number,
  screen_width: PropTypes.number,
  admin_email: PropTypes.string,
  dashboard_socket_details: PropTypes.object,
  history: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(PageContainer));



// WEBPACK FOOTER //
// ./src/app/pagecontainer/index.js